[
  {
    "data_types": ["username", "password", "email address", "phone number", "birthday"],
    "category": "Account Information",
    "purposes": [
      {
        "reason": "Create and manage account",
        "evidence": [57, 58, 59, 60, 61],
        "certainty": "high"
      },
      {
        "reason": "Provide services, products, features",
        "evidence": [114, 115, 116, 117, 118],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [120, 121, 122, 123],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [191],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "messages",
      "posts",
      "comments",
      "voice messages",
      "custom emojis",
      "files",
      "profile information",
      "server information"
    ],
    "category": "User-Generated Content",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [63, 64, 65, 66, 114, 115, 116],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [140, 141, 142, 143, 144],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [120, 121, 122, 123],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [191],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "General public",
        "evidence": [160, 161, 162, 163, 164, 165],
        "certainty": "high"
      },
      {
        "party": "Third party service providers",
        "evidence": [169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "partially sensitive"
  },
  {
    "data_types": [
      "payment method",
      "billing information",
      "full name",
      "billing address",
      "last four digits of the credit card number",
      "bank account information",
      "tax identification information",
      "government issued identification"
    ],
    "category": "Payment Information",
    "purposes": [
      {
        "reason": "Process transactions or payments",
        "evidence": [72, 73, 74, 75],
        "certainty": "high"
      },
      {
        "reason": "Comply with legal requirements and authorities",
        "evidence": [153, 154, 155],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Longer for legal reasons and/or obligations",
        "evidence": [153, 154],
        "certainty": "high"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [73, 169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "sensitive"
  },
  {
    "data_types": [
      "friends you add",
      "users, bots, and apps you engage with",
      "servers or other communities you join and participate in",
      "roles in servers",
      "content moderation decisions you make",
      "purchases or sales you make on or through Discord",
      "game you are playing"
    ],
    "category": "Usage Data",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [78, 79, 80, 114, 115, 116, 118],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [134, 135, 136, 140, 141, 142, 143, 144],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [138, 139],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [120, 121, 122, 123],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [191],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "IP address",
      "operating system information",
      "browser information",
      "device settings",
      "microphone and/or camera",
      "log and event information",
      "pages, servers, and channels you visit",
      "activities you engage in",
      "features you use",
      "surfaces or embedded content you interact with"
    ],
    "category": "Device and Usage Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": [90, 91, 92, 93, 94, 114, 115, 116],
        "certainty": "high"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [140, 141, 142, 143, 144],
        "certainty": "high"
      },
      {
        "reason": "Security and identification",
        "evidence": [120, 121, 122, 123],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [191],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  },
  {
    "data_types": [
      "information from cookies",
      "information from third-party platforms",
      "referral link information",
      "demographic information",
      "engagement with other products and services outside of Discord"
    ],
    "category": "Third-Party and Cookie Information",
    "purposes": [
      {
        "reason": "Provide services, products, features",
        "evidence": "139, 140, 141, 142, 143, 144, 145, 159, 160, 161, 162, 163"
      },
      {
        "reason": "Improve and personalize services",
        "evidence": [140, 141, 142, 143, 144],
        "certainty": "high"
      },
      {
        "reason": "Targeted and personalized advertisements",
        "evidence": [138, 139],
        "certainty": "high"
      }
    ],
    "retention": [
      {
        "duration": "Until account deletion",
        "evidence": [191],
        "certainty": "medium"
      }
    ],
    "sharing": [
      {
        "party": "Third party service providers",
        "evidence": [169, 170],
        "certainty": "high"
      },
      {
        "party": "Authorities",
        "evidence": [176, 177, 178],
        "certainty": "high"
      }
    ],
    "sensitive": "not sensitive"
  }
]
